const mozillaFirefox = "Mozilla Firefox";
function getBrowser(isAppendingVersion) {
  // ブラウザ名称取得
  const ua = navigator.userAgent;
  const M = getBrowserVer(ua);
  // OS名称取得
  const os = getOs(isAppendingVersion, ua);
  const osVersion = getWindowBit(os, M[0]);
  const adobeVersion = getAcrobatVersion(M[0]);
  return {
    name: M[0],
    version: M[1],
    os: os,
    screenWidth: screen.width,
    screenHeight: screen.height,
    osVersion: osVersion,
    adobeVersion: adobeVersion
  };
}

function getBrowserVer(ua) {
  let tem;
  let M =
    ua.match(/(edge|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) ||
    [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    M[1] = "Internet Explorer";
    M[2] = tem[1];
  } else if (M[1] === "Chrome") {
    const oldTem = ua.match(/\bOPR|Edge\/(\d+)/);
    const newTem = ua.match(/\bOPR|Edg\/(\d+)/);
    tem = oldTem ? oldTem : newTem;
    if (tem != null) {
      M[1] = "Microsoft Edge";
      M[2] = tem[1];
    }
  } else if (M[1] === "Firefox") {
    M[1] = mozillaFirefox;
  } else if (M[1] === "Safari") {
    M[1] = "Safari";
  } else {
    M[1] = "";
  }
  // ブラウザバージョン取得
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) {
    M.splice(1, 1, tem[1]);
  }
  return M;
}

function getOs(isAppendingVersion, ua) {
  // OS名称取得
  let os = "";
  const clientStrings = [
    { s: "Windows 10", r: /(Windows 10.0|Windows NT 10.0)/ },
    { s: "Windows 8.1", r: /(Windows 8.1|Windows NT 6.3)/ },
    { s: "Windows 8", r: /(Windows 8|Windows NT 6.2)/ },
    { s: "Windows 7", r: /(Windows 7|Windows NT 6.1)/ },
    { s: "Windows Vista", r: /Windows NT 6.0/ },
    { s: "Android", r: /Android/ },
    { s: "Linux", r: /(Linux|X11(?!.*CrOS))/ },
    { s: "iOS", r: /(iPhone|iPad|iPod)/ },
    { s: "Mac OS", r: /(Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ }
  ];
  for (const id in clientStrings) {
    if (clientStrings.hasOwnProperty(id) && clientStrings[id].r.test(ua)) {
      os = clientStrings[id].s;
      break;
    }
  }
  if (!isAppendingVersion && /Windows/.test(os)) {
    return "Windows";
  }
  return os;
}

/**
 * OSビット取得
 * @return OSビット
 */
function getWindowBit(osName, browserName) {
  if (osName === "Linux" || osName === "Android" || osName === "iOS") {
    return " ";
  } else if (osName === "Mac OS") {
    let fullinfo = navigator.userAgent;
    fullinfo = fullinfo.split("Mac OS ")[1];
    fullinfo = getFullInfo(browserName, fullinfo);
    fullinfo = fullinfo.replace(/_/g, ".");
    return " " + fullinfo;
  } else {
    const ua = navigator.userAgent;
    const pf = navigator.platform;
    let bit_name;
    if (
      pf === "Win64" ||
      ua.indexOf("Win64") != -1 ||
      ua.indexOf("WOW64") != -1
    ) {
      bit_name = "64ビット版";
    } else if (ua.indexOf("MSIE") != -1 || pf === "Win32") {
      bit_name = "32ビット版";
    } else {
      bit_name = "";
    }
    return "(" + bit_name + ")";
  }
}

function getFullInfo(browserName, fullinfo) {
  if (browserName === mozillaFirefox) {
    fullinfo = fullinfo.split(";")[0];
  } else {
    fullinfo = fullinfo.split(")")[0];
  }
  return fullinfo;
}

function getAcrobatVersion(browserName) {
  let adobeVersion = null; //アドビバージョン
  try {
    //IEの場合
    if (browserName === "Internet Explorer") {
      //ブラウザからアドビのActiveXObjectを取得
      const control = new ActiveXObject("AcroPDF.PDF");

      //ActiveXObjectが存在する場合
      if (control) {
        const versions = control.GetVersions().split(",");
        const latest = versions[0].split("=");
        adobeVersion = parseFloat(latest[1]);
        return adobeVersion;
        //ActiveXObjectが存在しない場合
      } else {
        return adobeVersion;
      }
      // FFの場合
    } else if (browserName === mozillaFirefox) {
      return getAdobeVersionFirefox(adobeVersion);
      // その以外のブラウザ
    } else {
      return adobeVersion;
    }
  } catch (e) {
    return adobeVersion;
  }
}

function getAdobeVersionFirefox(adobeVersion) {
  for (const key in navigator.plugins) {
    const plugin = navigator.plugins[key];
    if (plugin.name && plugin.name.indexOf("Adobe Acrobat") !== -1) {
      adobeVersion = plugin.version;
      if (!adobeVersion) {
        adobeVersion = plugin.description.match(/\d+\.\d+/)[0];
      }
      adobeVersion = parseFloat(adobeVersion);
      return adobeVersion;
    }
  }
  return adobeVersion;
}

export default { getBrowser };
